import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_EQUIPMENT_DETAILS: createAsyncActionConstants('FETCH_EQUIPMENT_DETAILS'),
    FETCH_EQUIPMENT_HEADER: createAsyncActionConstants('FETCH_EQUIPMENT_HEADER'),
    FETCH_EQUIPMENT_CHARGES: createAsyncActionConstants('FETCH_EQUIPMENT_CHARGES'),
    FETCH_EQUIPMENTS: createAsyncActionConstants('FETCH_EQUIPMENTS'),
    RESET_EQUIPMENTS: createAsyncActionConstants('RESET_EQUIPMENTS'),
    EQUIPMENT_ACCESS_DENIED: 'EQUIPMENT_ACCESS_DENIED',
}